module.exports = __webpack_public_path__ + "media/ketang-intro.038b6320.mp4";